import { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import { useQuery } from "@tanstack/react-query";
import { MessageSquareDashed } from "lucide-react";
import { api } from "@/lib/api";
import { Sheet, SheetContent, SheetTitle } from "@/components/ui/sheet";
import { InboxFilters } from "@/components/inbox/InboxFilters";
import { ChatList } from "@/components/inbox/ChatList";
import { ChatWindow } from "@/components/inbox/ChatWindow";
import { CrmPanel } from "@/components/inbox/CrmPanel";

export default function Inbox() {
  const [filter, setFilter] = useState("all");
  const [tag, setTag] = useState(null);
  const [search, setSearch] = useState("");
  const [selectedId, setSelectedId] = useState(null);
  const [crmOpen, setCrmOpen] = useState(false);
  const [params, setParams] = useSearchParams();
  useEffect(() => {
    const c = params.get("c");
    if (c) { setSelectedId(c); setFilter("all"); setParams({}, { replace: true }); }
  }, [params, setParams]);

  const { data } = useQuery({
    queryKey: ["conversations", filter, tag, search],
    queryFn: () => api.get("/conversations", { params: { filter, tag: tag || undefined, q: search || undefined } }).then((r) => r.data),
    refetchInterval: 4000,
  });
  const items = data?.items || [];
  const { data: selected } = useQuery({
    queryKey: ["conversation", selectedId],
    queryFn: () => api.get(`/conversations/${selectedId}`).then((r) => r.data),
    enabled: !!selectedId,
    refetchInterval: 4000,
  });

  return (
    <div className="h-full flex">
      <InboxFilters filter={filter} setFilter={setFilter} tag={tag} setTag={setTag} counts={data?.counts} onCreated={setSelectedId} />
      <ChatList items={items} selectedId={selectedId} onSelect={setSelectedId} search={search} setSearch={setSearch} filter={filter}
        setFilter={setFilter} tag={tag} setTag={setTag} counts={data?.counts} className={selectedId ? "hidden md:flex" : "flex"} />
      {selected ? (
        <div className="flex-1 flex min-w-0">
          <ChatWindow conversation={selected} onClosed={() => setSelectedId(null)} onBack={() => setSelectedId(null)} onOpenCrm={() => setCrmOpen(true)} />
          <CrmPanel key={selected.id} conversation={selected} className="hidden xl:flex" />
          <Sheet open={crmOpen} onOpenChange={setCrmOpen}>
            <SheetContent side="right" className="p-0 w-full sm:max-w-sm flex flex-col" data-testid="crm-sheet">
              <SheetTitle className="sr-only">Scheda cliente</SheetTitle>
              <CrmPanel key={`m-${selected.id}`} conversation={selected} className="flex flex-1 w-full border-l-0 min-h-0" />
            </SheetContent>
          </Sheet>
        </div>
      ) : (
        <div data-testid="inbox-empty-state" className="flex-1 hidden md:grid place-items-center chat-wallpaper">
          <div className="text-center max-w-xs">
            <div className="w-16 h-16 mx-auto rounded-2xl bg-white border border-slate-200 grid place-items-center shadow-sm">
              <MessageSquareDashed className="text-slate-400" />
            </div>
            <h3 className="mt-4 font-semibold text-slate-800">Seleziona una conversazione</h3>
            <p className="text-sm text-slate-500 mt-1">Scegli una chat dall'elenco per rispondere al cliente e gestire i dati CRM.</p>
          </div>
        </div>
      )}
    </div>
  );
}
